import React from 'react'
import TextArea from 'antd/es/input/TextArea'
import { Form } from 'antd'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'
import Access from '../../../../../../components/access/Access'
import Text from 'antd/es/typography/Text'

const TestMainClassName = ({ initialValue }) => {
    return (
        <Form.Item label='Main Class Name' name='mainClassName'>
            <Access
                rules={[Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED]}
                fallback={<Text>{initialValue ?? 'No main class name'}</Text>}
            >
                <TextArea />
            </Access>
        </Form.Item>
    )
}

export default TestMainClassName
